import { router } from '@inertiajs/react'
import { CaretLeft, CaretRight } from '@phosphor-icons/react'

interface MonthNavigationProps {
  month: string // "YYYY-MM"
}

function shiftMonth(month: string, delta: number): string {
  const date = new Date(month + '-01')
  date.setMonth(date.getMonth() + delta)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

function formatMonth(month: string): string {
  const date = new Date(month + '-01')
  return date.toLocaleDateString('pl-PL', { month: 'long', year: 'numeric' })
}

export function MonthNavigation({ month }: MonthNavigationProps) {
  const goTo = (newMonth: string) => {
    router.get('/calendar', { month: newMonth }, { preserveState: true })
  }

  return (
    <div className="flex items-center gap-md">
      <button
        onClick={() => goTo(shiftMonth(month, -1))}
        className="text-frame transition-colors hover:text-ink p-xs"
        aria-label="Poprzedni miesiąc"
      >
        <CaretLeft weight="bold" size={18} />
      </button>
      <span className="font-display text-lg tracking-wide capitalize min-w-[12rem] text-center">
        {formatMonth(month)}
      </span>
      <button
        onClick={() => goTo(shiftMonth(month, 1))}
        className="text-frame transition-colors hover:text-ink p-xs"
        aria-label="Następny miesiąc"
      >
        <CaretRight weight="bold" size={18} />
      </button>
    </div>
  )
}
